import { render } from "./LayoutPool.vue?vue&type=template&id=741b366e&scoped=true&ts=true"
import script from "./LayoutPool.vue?vue&type=script&lang=ts"
export * from "./LayoutPool.vue?vue&type=script&lang=ts"

import "./LayoutPool.vue?vue&type=style&index=0&id=741b366e&lang=scss&scoped=true"

import exportComponent from "D:\\zhangjc\\zhangjc_pro\\Edensoft.AIManage\\Edensoft.AIManageGit\\Edensoft.AIManage\\Edensoft.AIManage.PPTCopilot.PPTist.Apache-2.0\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-741b366e"]])

export default __exports__